import React, { useRef } from 'react'
import { useDrop } from 'react-dnd'
import { throttle } from 'lodash'
import { ItemTypes } from './ItemTypes'
import NewAnswer from './NewAnswer'
import perms from 'lib/perms'

/**
 * @typedef {Object} AnswerDragItem
 * @property {boolean} can_edit_quest
 * @property {{id: string}} answer
 * @property {string} initial_quest_id
 * @property {string} name
 * @property {Function} delete_local
 * @property {number} initial_ix
 * @property {string} quest_id
 */

export default props => {
    const ref = useRef(null)
    const [, drop] = useDrop({
        accept: ItemTypes.ANSWER,
        drop(item, monitor) {
            const dragItem = /** @type {AnswerDragItem} */ (/** @type {unknown} */ (item))
            if (!ref.current) {
                return { error: true }
            }

            const canEditTarget = perms.amQuestOwner(props.quest) || perms.amQuestAdmin(props.quest)
            const canEditSource = dragItem.can_edit_quest
            const isOwnParent =
                props.quest.side_quest && dragItem.answer.id === props.quest.parent_id

            if (!canEditTarget || !canEditSource || isOwnParent) {
                return { error: true }
            }
            // Don't replace items with themselves
            if (
                dragItem.initial_quest_id !== props.quest.id &&
                (!props.quest.side_quest || dragItem.answer.id !== props.quest.parent.id)
            ) {
                props.appendAnswerToQuest(dragItem.name)
                dragItem.delete_local(dragItem.initial_ix)
            }
            dragItem.quest_id = props.quest.id
        },
    })

    drop(ref)
    return (
        <div ref={ref} className="new-answer-dnd-wrapper-comp limit-selection">
            <NewAnswer ref={props.newAnswerRef} {...props} />
        </div>
    )
}
